export enum AnalyticTypesEnum {
    ACTIVE_MINUTES = "ACTIVE_MINUTES",
    NUMBER_OF_TRIALS = "NUMBER_OF_TRIALS",
    NUMBER_OF_HW_SENT = "NUMBER_OF_HW_SENT",
}
